export default __webpack_public_path__ + "static/media/wishlist.3c154e4f.svg";